import { lazyLoad } from 'app/utils/loadable';

export const ActivationPage = lazyLoad(
  () => import('./activation-page'),
  (module) => module.ActivationPage
);
